import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqItems = [
  {
    question: "¿Cuál es el horario?",
    answer:
      "Nuestro horario es de lunes a viernes de 10:00 a 13:30 y de 16:30 a 19:30, y los sábados de 10:00 a 13:00. Para urgencias fuera de horario, llama al centro o acude a un servicio de urgencias veterinarias.",
  },
  {
    question: "¿Atendéis urgencias?",
    answer:
      "Sí, atendemos urgencias durante nuestro horario de apertura. Fuera de horario, contamos con un servicio de guardia telefónica que te orientará sobre cómo actuar y, si es necesario, te derivará al centro de urgencias más cercano. Si tu mascota no respira bien, convulsiona o ha ingerido tóxicos (chocolate/medicación), acude a urgencias.",
  },
  {
    question: "¿Dónde estáis?",
    answer:
      "Nos encontramos en Carrer Exemple 123, Girona, con fácil acceso en transporte público y aparcamiento cercano.",
  },
  {
    question: "¿Hay que venir en ayunas para analíticas?",
    answer:
      "Sí, recomendamos un ayuno de al menos 8 horas antes de la extracción de sangre para que los resultados sean fiables. El agua sí se puede ofrecer con normalidad.",
  },
  {
    question: "¿Cuándo vacunar un cachorro?",
    answer:
      "Los cachorros comienzan su protocolo de vacunación a partir de las 6-8 semanas de vida, con refuerzos cada 3-4 semanas hasta completar la pauta. Tu veterinario te dará un calendario personalizado.",
  },
  {
    question: "¿Cada cuánto desparasitar?",
    answer:
      "Lo habitual es desparasitar internamente cada 3 meses y externamente de forma mensual o según el producto utilizado. En cachorros, el protocolo es más frecuente al inicio.",
  },
  {
    question: "¿Qué hago si mi perro come chocolate?",
    answer:
      "El chocolate es tóxico para los perros. Contacta inmediatamente con tu veterinario o con urgencias indicando el tipo de chocolate, la cantidad ingerida y el peso de tu perro. No provoques el vómito sin indicación profesional.",
  },
  {
    question: "¿Cómo pedir cita?",
    answer:
      "Puedes pedir cita fácilmente a través de nuestro asistente virtual. Solo tienes que pulsar el botón \"Pedir cita\" o escribir directamente en el chat. El asistente te guiará paso a paso.",
  },
];

export const FAQSection = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-muted/40"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-2xl">
        <div className="text-center mb-14 md:mb-16">
          <span className="text-sm font-medium tracking-wide uppercase text-primary/80 mb-3 block">
            Preguntas frecuentes
          </span>
          <h2
            data-testid="faq-title"
            className="text-3xl md:text-4xl font-bold text-foreground tracking-tight"
          >
            Resolvemos tus dudas
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqItems.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              data-testid={`faq-item-${index}`}
              className="bg-white rounded-xl border border-border/50 px-6 shadow-[0_2px_8px_-2px_rgba(0,0,0,0.04)] data-[state=open]:shadow-[0_4px_16px_-4px_rgba(0,0,0,0.08)] transition-shadow"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${index}`}
                className="text-left text-base font-medium text-foreground hover:no-underline py-5"
              >
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Disclaimer legal/sanitario */}
        <div data-testid="faq-disclaimer" className="mt-8 text-center">
          <p className="text-xs text-muted-foreground/80 leading-relaxed">
            Este asistente orienta y no sustituye la valoración veterinaria. En caso de urgencia, llama o acude al centro.
          </p>
        </div>
      </div>
    </section>
  );
};
